export function GenericClass<Props>(): new () => Props {
  return class {
    constructor() {
      Object.assign(this, {});
    }
  } as new () => Props;
}

export function transformObjectToPath<T extends object | string>(
  suffix: string,
  objectToTransformOrEndOfPath: T,
  path = ''
): Record<string, object | string> | string {
  if (typeof objectToTransformOrEndOfPath === 'object') {
    const transformedObject: Record<string, string | object> = {};
    for (const [key, value] of Object.entries(
      objectToTransformOrEndOfPath as Record<string, string | object>
    )) {
      transformedObject[key] = transformObjectToPath(
        key,
        value,
        concatIfExistsPath(path, suffix)
      );
    }
    return transformedObject as Record<string, object>;
  } else {
    return concatIfExistsPath(path, suffix) as string;
  }
}

function concatIfExistsPath(path: string, suffix: string): string {
  return path ? `${path}.${suffix}` : suffix;
}
